import { useEffect } from "react";
import {
  AppBar,
  Body,
  DescriptionText,
  LoadingPage,
  Title,
} from "../components";
import { ServiceList, ErrorPage } from "../shared";
import { Box } from "@mui/material";
import { useQueryTheme } from "../api/queries";
import { ThemeProps } from "../models/theme";
import { useAuth, useTheme } from "../hooks";
import { useParams } from "react-router-dom";
import { getStorageToken, isErrorResponse } from "../utils";
import { useTranslation } from "react-i18next";

const HomePage = () => {
  const { corporateName = "" } = useParams<{ corporateName: string }>();
  const { t } = useTranslation();
  const token = getStorageToken();
  const {
    data,
    isLoading: isLoadingTheme,
    isError,
    error,
  } = useQueryTheme({
    corporateName,
    enabled: !!token && !!corporateName,
    authorisation: token || "",
  });
  const { updateTheme, theme } = useTheme();

  useEffect(() => {
    updateTheme(data as ThemeProps);
  }, [data]);

  if (isErrorResponse(data) || isError || !!error) {
    return <ErrorPage />;
  }

  return isLoadingTheme ? (
    <LoadingPage />
  ) : (
    <Body>
      <AppBar theme={theme} />
      <Box my={5} mt={8}>
        <Title>{t("homepage.title")}</Title>
        <DescriptionText>{t("homepage.description_1")}</DescriptionText>
        <DescriptionText>{t("homepage.description_2")}</DescriptionText>
      </Box>
      <ServiceList />
    </Body>
  );
};

export default HomePage;
